module.exports = __webpack_public_path__ + "img/struc-circ-column.733ddbe0.jpg";